import React from 'react';
import { LoadingIndicator } from '@spotify-internal/encore-web';
import { css } from 'emotion';
import styled from '@emotion/styled';

export type WrapperLoadingIndicatorProps = {
  height?: number;
  color?: string;
};

export type CenteredLoadingIndicatorProps = Pick<
  WrapperLoadingIndicatorProps,
  'height'
> & {
  size?: 'sm' | 'md' | 'lg';
};

export type PageLoadingIndicatorProps = Pick<
  WrapperLoadingIndicatorProps,
  'color'
>;

const Wrapper = styled.div<WrapperLoadingIndicatorProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${({ height }) => {
    return height ? `${height}px` : '100%';
  }};
  background: ${({ color }) => color}};
`;

export const CenteredLoadingIndicator = (
  props: CenteredLoadingIndicatorProps
) => {
  const { height, size = 'sm' } = props;
  return (
    <Wrapper height={height} data-testid="loadingSpinner">
      <LoadingIndicator indicatorSize={LoadingIndicator[size]} />
    </Wrapper>
  );
};

export const PageLoadingIndicator = (props: PageLoadingIndicatorProps) => {
  const { color } = props;
  return (
    <Wrapper height={400} color={color} data-testid="loadingSpinner">
      <LoadingIndicator indicatorSize={LoadingIndicator.lg} />
    </Wrapper>
  );
};

export const InvertedLoadingIndicator = (
  props: WrapperLoadingIndicatorProps
) => {
  const { height } = props;
  return (
    <Wrapper height={height} data-testid="loadingSpinner">
      <LoadingIndicator
        indicatorSize={LoadingIndicator.lg}
        // I think we might be able to update this to inverted theme
        className={css`
          circle {
            fill: white !important;
          }
        `}
      />
    </Wrapper>
  );
};
